export class HttpStatusCode {
    public static HTTP_OK :string  = "200";
    public static HTTP_CREATED :string  = "201";
    public static HTTP_NO_CONTENT: string = "204";
    public static HTTP_BAD_REQUEST :string  = "400";
    public static HTTP_NOT_FOUND :string  = "404";
    public static HTTP_GONE :string  = "410";
    public static HTTP_INTERNAL_SERVER_ERROR : string = "500";

}
